import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import notFound from "../../assets/images/notFound.png";

const NotFound = ({ frase }) => {
  const [search, setSearch] = useState("");
  const { t } = useTranslation();

  return (
    <div className="flex flex-col justify-center">
      <div className="flex flex-row justify-center">
        <img src={notFound} className="w-100 max-w-md h-auto" />
      </div>
      <div className="flex flex-row justify-center">
        <h1 className="text-lg text-gray-700 -mt-9 font-medium  dark:text-gray-300">
          {frase}
        </h1>
      </div>
    </div>
  );
};

export default NotFound;
